import React, { Component } from 'react';
import { NavLink } from "react-router-dom";

class SideLink extends Component {
    render() {
        return (
            <NavLink activeClassName={"inact"} exact={this.props.Exact} className="nav-link mb-3 p-hover w3-hover-text-white w3-text-white" to={this.props.linkTo}>
                <div className="nav p-2">
                    <img src={this.props.imgLink} alt={this.props.altName} width="18" />
                    <span> &nbsp; &nbsp;{this.props.linkName}</span>
                </div>
            </NavLink>
        )
    }
}

export default SideLink